export const SET_QUOTES_DATA = 'socket/SET_QUOTES_DATA';
export const SET_MANY_QUOTES_DATA = 'socket/SET_MANY_QUOTES_DATA';
export const SET_ADVDEC_DATA = 'socket/SET_ADVDEC_DATA';
export const SET_TABLES_DATA = 'socket/SET_TABLES_DATA';
export const SET_NEWS_DATA = 'socket/SET_NEWS_DATA';
export const SET_EVENTS_DATA = 'socket/SET_EVENTS_DATA';
export const SET_CONNECTION_STATUS = 'socket/SET_CONNECTION_STATUS';

export const SET_VPMES_DATA = 'socket/SET_VPMES_DATA';
export const SET_VPMSPX_DATA = 'socket/SET_VPMSPX_DATA';
export const SET_VPMNQ_DATA = 'socket/SET_VPMNQ_DATA';
export const SET_VPMNDX_DATA = 'socket/SET_VPMNDX_DATA';

export const STOP_CHART_SOCKET = 'socket/STOP_CHART_SOCKET';
export const START_CHART_SOCKET = 'socket/START_CHART_SOCKET';

export const SET_WATCH_DATA = 'socket/SET_WATCH_DATA';
export const SET_MANY_WATCH_DATA = 'socket/SET_MANY_WATCH_DATA';

export const SET_CHART_DATA = 'socket/SET_CHART_DATA';

export const SUBSCRIBE_TO_SYMBOL = 'socket/SUBSCRIBE_TO_SYMBOL';
export const UNSUBSCRIBE_FROM_SYMBOL = 'socket/UNSUBSCRIBE_FROM_SYMBOL';
